import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { sendingDomainMethodLabel } from "../sendingDomainHelpers";
import {
    isSuggestedSendingDomainRow,
    type SendingDomainRow,
} from "../sendingDomainsViewConfig";

export const MethodCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingDomainRow, string>) => (
        <ViewTableCell>
            {isSuggestedSendingDomainRow(row.original)
                ? null
                : sendingDomainMethodLabel(row.original.method)}
        </ViewTableCell>
    ),
);
